import React, { useEffect, useState } from 'react'
import config from "../../config/config.json";
import  axios  from 'axios';



const ProfileDetails = () => {
    const { API_BASE_URL, userType } = config;
    const [userProfile,setUserProfile]= useState(null);



    useEffect(()=>{
        const userSession = JSON.parse(localStorage.getItem('user'));
        if(userSession && userSession.uuid){
            const userId  = userSession.result.userID;
            if(userId){
                getAssignCourse(userId)
            }
            // setUserId(userId);
          
        }else{
            console.error("localstorage data");
        }
      
    },[])
    const getAssignCourse = async (userId)=>{

      
        try{
            const response =  await axios.post(`${API_BASE_URL}/User/GetStudentDetailsByID`,{
                UserID:userId,
                ID:-1
            })
            console.log(response.data[0])
            setUserProfile(response.data[0]);

        }catch(error){
            console.log("error",error)

        }
    }
   
  return (
<div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 py-10 px-4">
  <div className="max-w-4xl mx-auto">

    {/* Profile Card */}
    <div className="bg-white/80 backdrop-blur-lg shadow-xl rounded-2xl p-8">

      {/* Header */}
      <div className="flex items-center gap-6 mb-8 border-b pb-6">
        <div className="w-20 h-20 rounded-full bg-blue-500 flex items-center justify-center text-white text-2xl font-bold shadow-md">
          {userProfile?.FirstName?.charAt(0)}
        </div>

        <div>
          <h1 className="text-2xl font-bold text-gray-800">
            {userProfile?.FirstName} {userProfile?.LastName}
          </h1>
          <p className="text-gray-500 text-sm">
            {/* {userType === "LMS" ? "LMS User" : "Educrapter User"} */} Profile
          </p>
        </div>
      </div>

      {/* Form */}
      <form className="space-y-8">

        {/* Section Title */}
        <h2 className="text-lg font-semibold text-gray-700">
          Personal Information
        </h2>

        <div className="grid md:grid-cols-2 gap-6">

          {/* First Name */}
          <div>
            <label className="text-sm text-gray-500">First Name</label>
            <input
              type="text"
              value={userProfile?.FirstName}
              disabled
              className="mt-1 w-full px-4 py-2.5 rounded-lg bg-gray-100 border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          {/* Last Name */}
          <div>
            <label className="text-sm text-gray-500">Last Name</label>
            <input
              type="text"
              value={userProfile?.LastName}
              disabled
              className="mt-1 w-full px-4 py-2.5 rounded-lg bg-gray-100 border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          {/* Email */}
          <div>
            <label className="text-sm text-gray-500">Email Address</label>
            <input
              type="email"
              value={userProfile?.EmailId}
              disabled
              className="mt-1 w-full px-4 py-2.5 rounded-lg bg-gray-100 border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          {/* Mobile */}
          <div>
            <label className="text-sm text-gray-500">Mobile Number</label>
            <input
              type="text"
              value={userProfile?.MobileNumber}
              disabled
              className="mt-1 w-full px-4 py-2.5 rounded-lg bg-gray-100 border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

        </div>

        {/* Buttons */}
        {/* <div className="flex justify-end gap-4 pt-6 border-t">
          <button
            type="button"
            className="px-5 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
          >
            Edit
          </button>

          <button
            type="submit"
            className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 shadow-md transition"
          >
            Save Changes
          </button>
        </div> */}

      </form>
    </div>
  </div>
</div>
   
  )
}

export default ProfileDetails